<div class="modal-header">
  <h3 class="modal-title">Calendario</h3>
  <button type="button" class="close text-primary" aria-label="Close"
	 (click)="closeModal()">
	 <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
	<!--<app-calendar-view
		[reqIdCaView]="requirementId"
		[idUrlCaView]="idUrlAditional"
	>
	</app-calendar-view>-->
</div>
<div class="modal-footer">
	<div class="row">
		<div class="col-md-12 text-right">
			<button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
				(click)="closeModal()">
				Cerrar
			</button>
		</div>
	</div>
</div>

